import React from 'react';
import ReviewSummary from 'component/page/detail/Review/ReviewSummary/ReviewSummary';
import ReviewOverlay from 'component/page/detail/Review/ReviewOverlay/ReviewOverlay';
import { connect, useSelector } from 'react-redux';
import { mapStateToProps, ReviewSectionModularProps } from 'component/page/detail/Review/Review.selectors';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesReviewContainerSeenEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { ActivitiesReviewContainerSeenEventActivitiesManifestV1 } from '@agoda/analytics-messages-definition-activities/manifest/events';
import ReviewListContainer from 'component/page/detail/Review/ReviewList/ReviewListContainer';
import { selectScreenSize } from 'store/slice/screen';
import { InView } from 'react-intersection-observer';
import { ReviewSectionVariant } from 'component/page/detail/DetailPageModularize/detailPageModularize.types';

const ReviewSectionModular: React.FC<ReviewSectionModularProps> = (props) => {
    const screenSize = useSelector(selectScreenSize);

    if (props.isHideReview) {
        return null;
    }
    const onSeen = (inView: boolean) => {
        if (inView && !props.isLoading && ((props.reviewList && props.reviewList.length > 0) || props.currentFilter.valueFilters.length > 0)) {
            trackElementEvent<ActivitiesReviewContainerSeenEventActivitiesFieldsV1>(ActivitiesReviewContainerSeenEventActivitiesManifestV1.ids, {
                is_toggle_on: true,
            });
        }
    };

    return (
        <InView onChange={onSeen} triggerOnce={true} threshold={1}>
            {props.variant === ReviewSectionVariant.Full && <ReviewListContainer isInOverlay={false} />}
            {props.variant === ReviewSectionVariant.Overview && <ReviewSummary />}
            {props.variant === ReviewSectionVariant.OverviewOnMobile && (screenSize.tabletOrDesktop ? <ReviewListContainer isInOverlay={false} /> : <ReviewSummary />)}
            <ReviewOverlay />
        </InView>
    );
};
ReviewSectionModular.displayName = 'ReviewSectionModular';

export default connect(mapStateToProps)(ReviewSectionModular);
